const PlusIcon = ({ ...props }) => {
  return (
    <svg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <mask id='mask0_1587_1472' maskUnits='userSpaceOnUse' x='0' y='0' width='15' height='15'>
        <path d='M14.4 0H0V14.4H14.4V0Z' fill='white' />
      </mask>
      <g mask='url(#mask0_1587_1472)'>
        <path
          d='M12.8145 6.36063H7.91994V1.4663C7.91994 1.08006 7.60698 0.76709 7.22073 0.76709C6.8345 0.76709 6.52155 1.08006 6.52155 1.4663V6.36063H1.62742C1.24118 6.36063 0.928223 6.67359 0.928223 7.05984C0.928223 7.44607 1.24118 7.75905 1.62742 7.75905H6.52157V12.6529C6.52157 13.0392 6.83452 13.3522 7.22075 13.3522C7.60699 13.3522 7.91995 13.0392 7.91995 12.6529V7.75905H12.8145C13.2007 7.75905 13.5137 7.44607 13.5137 7.05984C13.5137 6.67358 13.2007 6.36063 12.8145 6.36063Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
};

export default PlusIcon;
